import { useTranslation } from 'react-i18next';

import { Button, ModalBody, ModalCloseButton, ModalFooter, ModalHeader, rem, Text } from '@bonusly/design-system';
import { useAnalytics } from '@bonusly/who-am-i';

import { AwardSelectionList } from './AwardSelectionList';
import { ModalBanner } from './ModalBanner';
import { NoAwardSelected } from './NoAwardSelected';
import { useAwardModalState } from './state';

export const SelectAwardContent = () => {
	const { goToGiveAward, isMissingSelection } = useAwardModalState();
	const { t } = useTranslation(['common', 'recognition']);
	const { track } = useAnalytics();
	return (
		<>
			<ModalHeader
				alignItems="center"
				borderBottomWidth={rem(1)}
				borderColor="gray.100"
				borderStyle="solid"
				color="gray.900"
				display="flex"
				justifyContent="space-between"
				px={5}
				py={4}
			>
				<Text as="span" color="gray.900" fontSize="lg" fontWeight="semibold" lineHeight={8}>
					{t('awards.give_modal.select_award_header', { ns: 'recognition' })}
				</Text>
				<ModalCloseButton
					bg="blackAlpha.50"
					borderRadius="full"
					data-testid="modal-close-button"
					h={rem(36)}
					onClick={() => track('Award Give Cancel', { screen: 'select_award' })}
					pos="static"
					w={rem(36)}
					_hover={{ bg: 'blackAlpha.100' }}
				/>
			</ModalHeader>

			<ModalBody p={0}>
				<ModalBanner />
				{isMissingSelection && <NoAwardSelected px={5} py={4} />}
				<AwardSelectionList />
			</ModalBody>

			<ModalFooter>
				<Button onClick={goToGiveAward} size="lg">
					{t('next', { ns: 'common' })}
				</Button>
			</ModalFooter>
		</>
	);
};
